import React from 'react';
import intl from '$intl';
import { IonContent } from '@ionic/react';

import { Button } from '$gcomponents/primitives';
import OrderModel from '$fbusiness/models/order';
import Footer from '$gcomponents/widgets/footer';
import InvoiceModel from '$fbusiness/models/invoice';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import ORDER_EDIT_FORM from './orderUpdateForm';
import { useSelector } from 'react-redux';
import { PageWrapper } from '$gstyles/wrapper';
import { parseISO } from 'date-fns';

interface OrderUpdateDetailsProps {
  order?: OrderModel;
  invoice?: InvoiceModel;
  onSubmitOrder: Function;
  onClose: () => void;
}

const OrderUpdateDetails: React.FC<OrderUpdateDetailsProps> = ({
  order,
  invoice,
  onClose,
  onSubmitOrder,
}) => {
  const factory = useSelector((state: any) => state.factory.factory);
  const shippingOptions = factory.shippings.map((item) => ({
    labelText: item.name,
    value: item.id,
  }));

  if (!order && !invoice) return null;

  const initialValues = {
    id: order?.id || invoice?.id,
    shippingId: order?.shippingId || '',
    note: order?.note || invoice?.note,
    deliveredDate: order?.deliveredDate ? parseISO(order.deliveredDate) : null,
  };

  const onSubmit = (values) => {
    onSubmitOrder(values);
  };

  const orderForm = ORDER_EDIT_FORM({ shippingOptions, settings: factory.settings });

  const validateForm = (values) => {
    return input.validateError(orderForm, values);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <>
          <IonContent>
            <PageWrapper>
              <FormSection FORM={orderForm} formik={formik} />
            </PageWrapper>
          </IonContent>
          <Footer>
            <Button onClick={onClose} variant="outlined">
              {intl('BUTTON.CANCEL')}
            </Button>
            <Button onClick={formik.submitForm}>{intl('BUTTON.UPDATE')}</Button>
          </Footer>
        </>
      )}
    </Formik>
  );
};

export default OrderUpdateDetails;
